export class VehicleAttributeCategoryModel {
    public instanceHashId: string = "";
    public vehicleAttributeCategoryName: string;
    public vehicleAttributeCategoryHashId: string;
    public instanceName: string;
    public isEditable:boolean;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/vehicle-attribute-category/models/vehicleattributecategory.model.ts